// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountdownComponent } from './countdown/countdown.component';
import { CameraComponent } from './camera/camera.component';
import { WebcamModule } from 'ngx-webcam';
import { GalleryGridComponent } from './gallery-grid/gallery-grid.component';
import { ToasterComponent } from './toaster/toaster.component';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import { ConfirmationPopupComponent } from './confirmation-popup/confirmation-popup.component';
import { LightboxComponent } from './lightbox/lightbox.component';
import { UploadModalComponent } from './upload-modal/upload-modal.component';
import { EgDropdownComponent } from '../wrappers/eg-dropdown/eg-dropdown.component';
import { EgSectionHeaderComponent } from '../wrappers/eg-section-header/eg-section-header.component';
import { DisableRightAndLongpressDirective } from './disable-right-and-longpress.directive';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FormsModule } from '@angular/forms';
import { ThemeSwitcherComponent } from './theme-switcher/theme-switcher.component';

@NgModule({
  declarations: [
    CountdownComponent,
    CameraComponent,
    GalleryGridComponent,
    ToasterComponent,
    ConfirmationPopupComponent,
    LightboxComponent,
    UploadModalComponent,
    EgDropdownComponent,
    EgSectionHeaderComponent,
    DisableRightAndLongpressDirective,
    ThemeSwitcherComponent,
  ],
  imports: [
    CommonModule,
    WebcamModule,
    LottieComponent,
    FormsModule,
    InfiniteScrollModule
  ],
  exports: [
    CountdownComponent,
    CameraComponent,
    GalleryGridComponent,
    ToasterComponent,
    ConfirmationPopupComponent,
    LightboxComponent,
    UploadModalComponent,
    EgDropdownComponent,
    EgSectionHeaderComponent,
    DisableRightAndLongpressDirective,
    ThemeSwitcherComponent
  ],
  providers: [
    provideLottieOptions({
      player: () => import('lottie-web')
    }),
  ]
})
export class SharedModule { }
